import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative py-32 bg-black text-white overflow-hidden" data-id="element-62">
      {/* Background Texture */}
      <div className="absolute inset-0 z-0 pointer-events-none" data-id="element-63">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gray-900 via-black to-black opacity-80" data-id="element-64" />
        <img src="https://cdn.magicpatterns.com/uploads/axEJoGvujZ4uxYtLew8s1r/5-landing_cta_banner_centered_2line_headline_1920x1080.png" alt="Background" className="w-full h-full object-cover opacity-20 mix-blend-overlay" data-id="element-65" />
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-66">
        <div className="flex flex-col items-center text-center" data-id="element-67">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="max-w-4xl mx-auto" data-id="element-68">
            <h2 className="text-7xl font-bold mb-8 leading-tight tracking-tight" data-id="element-69">
              <span className="block text-3xl text-[#C9A961] font-medium mb-4 uppercase tracking-widest" data-id="element-70">
                Este pack de ebooks edición premium
              </span>
              <span className="block mb-2" data-id="element-71">no te motiva.</span>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-200 to-gray-400" data-id="element-72">
                Te ordena.
              </span>
            </h2>

            <div className="w-24 h-1.5 bg-[#C9A961] mx-auto mb-8 rounded-full" data-id="element-73" />

            <p className="text-2xl text-gray-400 mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-74">
              Tu presencia no es un "talento". Es una habilidad entrenable. Este
              pack es tu atajo para que tu comunicación empiece a abrir puertas.
            </p>
          </motion.div>

          {/* Product Image Showcase */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 40
        }} whileInView={{
          opacity: 1,
          scale: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative w-full max-w-5xl mb-16" data-id="element-75">
            {/* Glow Effect */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-[#C9A961] blur-[120px] opacity-20 rounded-full pointer-events-none" data-id="element-76" />

            <img src="https://cdn.magicpatterns.com/uploads/hb4aF6X3XuCrATJ36jaKtR/collage_7_libros.png" alt="Pack Premium de 7 Ebooks" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:scale-[1.02] transition-transform duration-500 ease-out" data-id="element-77" />
          </motion.div>

          {/* CTA Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col items-center w-full" data-id="element-78">
            <div className="mt-10 flex flex-col items-center gap-4" data-id="element-79"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}